export default __webpack_public_path__ + "static/3_32-4ccfe33b382536ab2d0abd982e297159.png";